const { gql } = require('@apollo/client');

export const QUERY_APP_SETTINGS = gql`
  query AppSettings {
    appSettings {
      all {
        LicenseKey
        DeviceName
        NeverShowNotification
        AppStartup
        LicenseEndTime
        StartSendingInRuntime
        FullDebuggingMode
        IsAdministrator
        IsTunneled
        AppVersion
      }
    }
  }
`;

export const MUTATION_FEATURE_SETTINGS = gql`
  mutation AppSettings(
    $NeverShowNotification: Boolean!
    $AppStartup: Boolean!
    $StartSendingInRuntime: Boolean!
    $FullDebuggingMode: Boolean!
  ) {
    appSettings {
      update(
        appSettings: {
          NeverShowNotification: $NeverShowNotification
          AppStartup: $AppStartup
          StartSendingInRuntime: $StartSendingInRuntime
          FullDebuggingMode: $FullDebuggingMode
        }
      ) {
        NeverShowNotification
        AppStartup
        StartSendingInRuntime
        FullDebuggingMode
      }
    }
  }
`;

export const MUTATION_CLEAR_CACHE = gql`
  mutation AppSettings {
    appSettings {
      clearCache
    }
  }
`;

export const MUTATION_RESET_SETTINGS = gql`
  mutation AppSettings {
    appSettings {
      resetSettings
    }
  }
`;

export const MUTATION_NOTIFICATION_STATUS = gql`
  mutation AppSettings($NeverShowNotification: Boolean!) {
    appSettings {
      update(appSettings: { NeverShowNotification: $NeverShowNotification }) {
        NeverShowNotification
      }
    }
  }
`;
